<template>
  <div>
    <el-progress v-if="startTimer" :color="color" :percentage="percent" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProgressBar',
  props: {
    color: {
      type: String,
      default: '#409eff',
    },
    time: {
      type: Number,
      default: 2,
    },
    start: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      progress: 0,
      timer: '',
      step: 0,
      startTimer: false,
    }
  },
  computed: {
    ...mapGetters({
      percent: 'reports/getProgressBar',
    }),
  },
  watch: {
    startTimer() {
      if (this.startTimer) {
        this.ProgressOngoing()
      } else {
        this.StopProgressOngoing()
      }
    },
    progress() {
      if (this.progress >= 100) {
        this.progress = 0
      }
    },
  },
  mounted() {
    this.startTimer = this.start
    this.stepProgress()
  },
  methods: {
    ProgressOngoing() {
      this.timer = setInterval(() => {
        this.progress = this.progress + 1
      }, this.step)
    },
    StopProgressOngoing() {
      clearInterval(this.timer)
    },
    stepProgress() {
      this.step = this.time / 100
    },
  },
}
</script>

<style scoped></style>
